import { z } from "zod";
export const PageRedirect = z.object({
    id: z.string(),
    pagePersistentId: z.string(),
    path: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    designSystemId: z.string(),
});
